export default __webpack_public_path__ + "static/media/DeveloperAccess_domain_account_image_1.d63c42bd.png";